import { useCallback, useEffect, useMemo, useRef } from 'react';

import { useStatusContext } from 'pages/Status/context';
import { formatProvider } from 'utils';

interface DeclinedHook {
  failureUrl?: string;
  companyName: string;
  provider: string;
  isLoading: boolean;
}

export default function useDeclined(): DeclinedHook {
  const { job, jobCompanyInfo, provider, isLoading } = useStatusContext();

  const failureUrl = useMemo(() => job?.redirect_urls?.failure_url, [job]);

  const companyName = useMemo(() => {
    if (!jobCompanyInfo || isLoading) return 'Your tradesperson';
    return jobCompanyInfo?.company_name || 'Your tradesperson';
  }, [jobCompanyInfo, isLoading]);

  const formattedProvider = useMemo(() => {
    if (!provider) return '';
    if (provider === 'example') return 'example';
    return formatProvider(provider);
  }, [provider]);

  const timerRef = useRef<NodeJS.Timer | undefined>();

  const startTimeout = useCallback(() => {
    clearTimeout(timerRef.current as NodeJS.Timeout);
    timerRef.current = setTimeout(() => {
      window.location.assign(failureUrl as string);
    }, 10000);
  }, [failureUrl]);

  useEffect(() => {
    if (failureUrl) startTimeout();
    return () => clearTimeout(timerRef.current as NodeJS.Timeout);
  }, [failureUrl, startTimeout]);

  return {
    failureUrl,
    companyName,
    provider: formattedProvider,
    isLoading,
  };
}
